import React, { useState } from 'react';
import {
    TableRow,
    TableCell,
    IconButton,
    Tooltip,
    TextField,
    Checkbox,
    Select,
    MenuItem, 
} from '@mui/material';
import ClearIcon from "@mui/icons-material/Clear";
import CheckIcon from "@mui/icons-material/Check";
import translation from '../translations/updateProductFamilyFormTranslation';

const UpdateProductFamilyForm = ({ pf, rolesList, onSave, onCancel, onDelete }) => {
    const [editedPf, setEditedPf] = useState({ ...pf });

    const handleChange = (field, value) => {
        setEditedPf(prev => ({ ...prev, [field]: value }));
    };

    return (
        <TableRow>
            <TableCell>
                <TextField
                    value={editedPf.familyName}
                    disabled
                    onChange={(e) => handleChange('familyName', e.target.value)}
                    fullWidth
                />
            </TableCell>
            <TableCell>
                <TextField
                    value={editedPf.familyDes}
                    onChange={(e) => handleChange('familyDes', e.target.value)}
                    fullWidth
                />
            </TableCell>
            <TableCell>
                <TextField
                    value={editedPf.ft}
                    disabled
                    onChange={(e) => handleChange('ft', e.target.value)}
                    fullWidth
                />
            </TableCell>
            <TableCell>
                <Checkbox
                    checked={editedPf.orderApprovalRequired}
                    onChange={(e) => handleChange('orderApprovalRequired', e.target.checked)}
                />
            </TableCell>
          <TableCell>
                { editedPf.orderApprovalRequired && <Select
                    value={editedPf.approverRole?._id || ''}
                    onChange={(e) => handleChange('approverRole', rolesList.find(role => role._id === e.target.value))}
                    fullWidth
                >
                    {rolesList.map((role) => (
                        <MenuItem key={role._id} value={role._id}>{role.Name}</MenuItem>
                    ))}
                </Select>}
            </TableCell>
            <TableCell>
                <Tooltip title={translation.save}>
                    <IconButton onClick={() => onSave(editedPf)}
                        color="primary"
                    >
                        <CheckIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title={translation.save}>
                    <IconButton onClick={onCancel}
                        color="warning"
                        aria-label="cancel update">
                        <ClearIcon />
                    </IconButton>
                </Tooltip>
            </TableCell>
        </TableRow>
    );
};

export default UpdateProductFamilyForm;